import { render } from "./PersonalizedOffers.vue?vue&type=template&id=c5d6d4b8"
import script from "./PersonalizedOffers.vue?vue&type=script&lang=js"
export * from "./PersonalizedOffers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__